import { message } from 'antd'
import { observer } from 'mobx-react-lite'
import { lazy, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Padding } from 'components/ui'
import { Button, Flex, Skeleton, Text, Title } from 'components/uiKit'
import { getOrderItemRoute } from 'utils/helpers/routes/getRoutes'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'

import { OrderKeys } from '../OrderModule/data'
import { ActivateELockForm } from './components/ActivateELockForm/ActivateELockForm'

const ActivateELockPage = observer(() => {
  const { eLockUiStore: uiStore, viewOrderUiStore } = useStore()

  const { orderId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [messageApi, contextHolder] = message.useMessage()
  const [loading, setLoading] = useState(true)

  let timeout: NodeJS.Timeout

  useAsyncEffect(async () => {
    void checkNetwork()

    if (!viewOrderUiStore.selectedOrder && orderId) {
      await viewOrderUiStore.getOrderList()
      viewOrderUiStore.setSelectedOrder(viewOrderUiStore.getOrder(+orderId))
    }

    if (uiStore.order?.eLockInfo) {
      uiStore.initialize(uiStore.order.eLockInfo)
    }

    setLoading(false)
  }, [orderId])

  useEffect(() => {
    return () => {
      uiStore.reset()
      clearInterval(timeout)
    }
  }, [])

  const checkNetwork = () => {
    timeout = setInterval(async () => {
      const isOnline = await uiStore.checkNetwork()

      if (isOnline !== uiStore.isOnline) {
        isOnline === true
          ? messageApi.success({
              content: t(getKey('Приложение работает в онлайн')),
              duration: 6,
            })
          : messageApi.warning({
              content: t(getKey('Приложение работает в офлайн')),
              duration: 6,
            })

        uiStore.setIsOnline(isOnline)
      }
    }, 3000)
  }

  const getKey = (key: string) => `${OrderKeys.eLockModule}.${key}`

  return (
    <ContainerLK>
      <Padding py={32}>
        <Flex style={{ maxWidth: 700 }} vertical gap={32}>
          <Flex gap={16} align="center">
            <Button
              shape="circle"
              icon={<ArrowLeftOutlined />}
              onClick={() => orderId && navigate(getOrderItemRoute(+orderId))}
            />

            <Title level={2}>{t(getKey('Активация электронного замка'))}</Title>
          </Flex>

          <Skeleton loading={loading}>
            {!uiStore.isActive && (
              <Flex vertical gap={16}>
                <Text>{t(getKey('Чтобы активировать замок'))}</Text>

                <Text>{t(getKey('Подключите контроллер'))}</Text>
                <Text>{t(getKey('Введите имя замка'))}</Text>
                <Text>{t(getKey('Название и пароль Wifi'))}</Text>
              </Flex>
            )}

            <ActivateELockForm />
          </Skeleton>
        </Flex>
      </Padding>

      {contextHolder}
    </ContainerLK>
  )
})

export default ActivateELockPage

export const ActivateELockPageAsync = lazy(() => import('./ActivateELockPage'))
